// src/api/endpoints/config.ts
import api from '../client';
import { ApiResponse } from '@/types';

export const configApi = {
  // Priority endpoints
  getPriorities: () => 
    api.get<ApiResponse<{ data: any[] }>>('/config/priorities'),
  
  createPriority: (data: { name: string; color: string; order?: number }) => 
    api.post<ApiResponse<{ data: any }>>('/config/priorities', data),
  
  updatePriority: (id: string, data: { name?: string; color?: string; order?: number }) => 
    api.put<ApiResponse<{ data: any }>>(`/config/priorities/${id}`, data),
  
  deletePriority: (id: string) => 
    api.delete<ApiResponse<null>>(`/config/priorities/${id}`),
  
  // Status endpoints
  getStatuses: () => 
    api.get<ApiResponse<{ data: any[] }>>('/config/statuses'),
  
  createStatus: (data: { name: string; color: string; followUpRequired?: boolean; order?: number }) => 
    api.post<ApiResponse<{ data: any }>>('/config/statuses', data),
  
  updateStatus: (id: string, data: { name?: string; color?: string; followUpRequired?: boolean; order?: number }) => 
    api.put<ApiResponse<{ data: any }>>(`/config/statuses/${id}`, data),
  
  deleteStatus: (id: string) => 
    api.delete<ApiResponse<null>>(`/config/statuses/${id}`),
  
  // Task Template endpoints
  getTaskTemplates: () => 
    api.get<ApiResponse<{ data: any[] }>>('/config/task-templates'),
  
  createTaskTemplate: (data: { 
    name: string; 
    subTasks: string[]; 
    defaultPriority?: 'Low' | 'Medium' | 'High'; 
    defaultEstimatedTime?: number 
  }) => 
    api.post<ApiResponse<{ data: any }>>('/config/task-templates', data),
  
  updateTaskTemplate: (id: string, data: any) => 
    api.put<ApiResponse<{ data: any }>>(`/config/task-templates/${id}`, data),
  
  deleteTaskTemplate: (id: string) => 
    api.delete<ApiResponse<null>>(`/config/task-templates/${id}`),
  
  // Preferences endpoints
  getPreferences: () => 
    api.get<ApiResponse<{ data: any }>>('/config/preferences'),
  
  updatePreferences: (data: any) => 
    api.put<ApiResponse<{ data: any }>>('/config/preferences', data),
  
  updateBusinessDetails: (data: any) => 
    api.put<ApiResponse<{ data: any }>>('/config/business-details', data),
  
  uploadLogo: (file: File) => {
    const formData = new FormData();
    formData.append('logo', file);
    return api.post<ApiResponse<{ logoUrl: string }>>('/config/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};